import type { TeamMember } from "./teamMembers";

// Display-safe shape returned by GET /api/v1/idx/team-members. Names and email
// remain nullable here because legacy Spanner rows may predate those fields.
export interface IdxTeamMember {
  id: string;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  phone_number: string | null;
  photo_url: string | null;
  bio: string | null;
  slug: string | null;
}

export const toTeamMember = (
  member: IdxTeamMember,
  organizationId: string
): TeamMember => ({
  id: member.id,
  first_name: member.first_name ?? "",
  last_name: member.last_name ?? "",
  email: member.email ?? "",
  phone_number: member.phone_number ?? "",
  organization_id: organizationId,
  photo_url: member.photo_url ?? undefined,
  bio: member.bio ?? undefined,
  slug: member.slug ?? undefined,
});
